import * as Sentry from '@sentry/browser'
import { BrowserTracing } from '@sentry/tracing'
import { APP_RELEASE_TAG, APP_SENTRY_SERVICE, SENTRY_ENV, APP_SENTRY_DEBUG } from '../'
import { getHeaderSentry } from './headerSentry'

export const appSentryBrowserOptions: Sentry.BrowserOptions = {
  debug: APP_SENTRY_DEBUG || false,
  dsn: APP_SENTRY_SERVICE,
  environment: SENTRY_ENV != null ? SENTRY_ENV : 'not set',
  release:
    window.SENTRY_RELEASE?.id === APP_RELEASE_TAG ? window.SENTRY_RELEASE?.id : APP_RELEASE_TAG,
  defaultIntegrations: false,
  integrations: () => {
    return [
      ...Sentry.defaultIntegrations.filter((integration) => {
        return integration.name !== 'Dedupe'
      }),
      new BrowserTracing()
    ]
  },
  beforeSend (event) {
    try {
      // Try and get info about the event so it can be sent to the correct project.
      if (
        event.exception?.values?.some((value) =>
          value.stacktrace?.frames[value.stacktrace?.frames?.length - 1].filename.includes(
            'hb-header-app'
          )
        )
      ) {
        // Tag the event so we can see where it came from even if the below doesn't work for some reason.
        event.tags = {
          application: 'hb-header-app',
          'event-created-in-application': 'hb-t4-guest-proposals'
        }

        if (getHeaderSentry()[0] != null) {
          // Use the release for the header, not the running application.
          event.release = getHeaderSentry()[1]

          // Send the event to Sentry for the header.
          getHeaderSentry()[0].captureEvent(event)
          // Don't send the event to Sentry twice.
          return null
        } else {
          // Something went wrong but we still want to capture the event somewhere.
          return event
        }
      } else {
        return event
      }
    } catch (e) {
      console.error('SENTRY_HUB_ERROR_GUEST-PROPOSALS')
      return e
    }
  }
}
